import type { ReactNode } from 'react';

export const symbol_ballot: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M651-565q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5H483q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5h168Zm0 230q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5H483q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5h168ZM384.5-558.5Q400-574 400-595t-15.5-36.5Q369-647 348-647t-36.5 15.5Q296-616 296-595t15.5 36.5Q327-543 348-543t36.5-15.5Zm0 230Q400-344 400-365t-15.5-36.5Q369-417 348-417t-36.5 15.5Q296-386 296-365t15.5 36.5Q327-313 348-313t36.5-15.5ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z"
		/>
	</svg>
);
